exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3AqgUqtR63qOFNpWdxfd-4{line-height:1;font-size:14px;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir=ltr] ._3AqgUqtR63qOFNpWdxfd-4{margin-left:4px}html[dir=rtl] ._3AqgUqtR63qOFNpWdxfd-4{margin-right:4px}._3wTd75E6d0Gk4V5fi0k64F{line-height:32px;font-size:16px;width:32px;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._3wTd75E6d0Gk4V5fi0k64F{text-align:center}._31cyULSyeX6vpxPMp2-XTw{color:\"[theme:redDark, default:#a80000]\"}", ""]);
// Exports
exports.locals = {
	"size14": "_3AqgUqtR63qOFNpWdxfd-4",
	"size16": "_3wTd75E6d0Gk4V5fi0k64F",
	"red": "_31cyULSyeX6vpxPMp2-XTw"
};